import { config } from "../config";
import { toNumber as _ToNumber } from "lodash-es";
import * as moment from "moment";

export function toNumber(a: any) {
    if (a !== null && a !== undefined && !isNaN(a)) {
        return _ToNumber(a);
    } else {
        return null;
    }
}

export function buildPageTitle(
    title = "Untitled",
    base = `${config.SiteName} - `
) {
    return `${base}${title}`;
}

export function randomString(
    length: number,
    chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
) {
    let result = "";
    for (let i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)];
    return result;
}

export function base64toBlob(
    b64Data: string,
    contentType = "",
    sliceSize = 512
): Blob {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}

export function filePreviewUrl(file: File) {
    const promise = new Promise<{
        preview_url: string;
        type: string;
    }>(resolve => {
        const reader = new FileReader();

        reader.onload = (e: any) => {
            resolve({
                preview_url: e.target.result,
                type: file.type
            });
        };

        reader.readAsDataURL(file);
    });
    return promise;
}

export function imageUrl(img: any) {
    if (img.images && img.images.length > 0) {
        return img.images[0].path;
    } else {
        return img;
    }
}
